import { SetTriggerMapFocus } from '@modules/planning/children/by-date/types/map-container';

export const handleMapFocus = (setTriggerMapFocus: SetTriggerMapFocus) => (record: any) => setTriggerMapFocus([record]);
